export const button_master = {
    default : {
        backgroundColor: '#007aff',
        color: '#fff !important',
        boxShadow: '0 3px 0 0 #0147fe',
    },
    grey: {
        backgroundColor: '#eaeaea',
        color: '#333 !important',
        boxShadow: '0 3px 0 0 #dedede',
    },
    white: {
        backgroundColor: '#f5f5f5',
        color: '#000 !important',
        boxShadow: '0 3px 0 0 #dedede',
    }
}